<template>
  <div class="newsletter-form critical-component-clear dark">
    <div
      :style="`background-image: url(${settings.background_image})`"
      class="newsletter-form__background-image"
    />
    <div class="newsletter-form__container grid container">
      <div class="col xs12 l10 newsletter-form__content">
        <h1
          v-if="!isEmptyString(settings.title)"
          class="text-heading-s newsletter-form__content--title"
          v-text="settings.title"
        />
        <h2
          v-if="!isEmptyString(settings.subtitle)"
          class="text-heading-2xl-desktop text-heading-xl newsletter-form__content--subtitle"
          v-text="settings.subtitle"
        />
        <p
          v-if="!isEmptyString(settings.description)"
          class="text-body-s newsletter-form__content--description"
          v-text="settings.description"
        />
      </div>

      <div class="col xs12 l12-24 newsletter-form__form">
        <signup-form />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Newsletter form (newsletter-form)
 * -----------------------------------------------------------------------------
 * Newsletter form with blurry background image.
 *
 * @param {Object} settings - Section's settings.
 *
 */
import SignupForm from '~async/signup-form/signup-form'

export default {
  name: 'NewsletterForm',

  components: {
    SignupForm,
  },

  props: {
    settings: {
      type: Object,
      default: () => ({
        title: '',
        subtitle: '',
        description: '',
        background_image: '',
      }),
    },
  },

  methods: {

    /*
    * Returns true if text is empty string.
    */
    isEmptyString(text) {
      return text === ''
    },
  },
}
</script>

<style lang="scss">
@import './newsletter-form';
</style>
